import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrap"
}
const _hoisted_2 = {
  key: 0,
  class: "modal-body"
}

import { nextTick, ref, watch } from 'vue';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalTemplate',
  props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
  emits: ["handleCloseOver"],
  setup(__props, { emit: __emit }) {

    const emits = __emit;
    let props = __props;
    let wrapperVisible = ref(false);
    let bodyVisible = ref(false);
    watch(
        () => props.visible,
        (newValue: boolean, oldValue: boolean) => {
            if (newValue) {
                wrapperVisible.value = true;
                nextTick(() => {
                    bodyVisible.value = true;
                });
            } else {
                bodyVisible.value = false;
            }
        }
    );
    function onChildAfterLeave() {
        wrapperVisible.value = false;
    }

    function onWrapperAfterEnter() {
        bodyVisible.value = true;
    }

    function onLayerClose() {
        emits('handleCloseOver');
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "hideModal",
    onAfterEnter: onWrapperAfterEnter,
    onAfterLeave: onLayerClose
  }, {
    default: _withCtx(() => [
      (_unref(wrapperVisible))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_Transition, {
              name: "scale",
              onAfterLeave: onChildAfterLeave
            }, {
              default: _withCtx(() => [
                (_unref(bodyVisible))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "default")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})